import React from 'react';
import classNames from 'classnames';
import Image from 'next/image';

import {ButtonType, CommonProps} from './types';

import styles from './styles.module.scss';

export const isAnchorButtonProps = (as: ButtonType): boolean => {
  return as === 'anchor';
};

export const isButtonProps = (as: ButtonType): boolean => {
  return as === 'button';
};

export const isLinkProps = (as: ButtonType): boolean => {
  return as === 'link';
};

export const generateIconComponent = (
  iconProps: CommonProps['withIcon'],
  disabled: boolean,
) => {
  if (!iconProps?.iconSrc) {
    return null;
  }

  if (iconProps.iconSrc && iconProps.isFontAwesome) {
    return (
      <i
        className={classNames(
          styles.button__icon,
          iconProps.iconSrc,
          iconProps.iconClassName,
          {
            [styles.button__icon__modDisabled]: disabled,
          },
        )}
      />
    );
  }

  if (String(iconProps.iconSrc).startsWith('/static')) {
    return (
      <img
        className={classNames(styles.button__icon, iconProps.iconClassName, {
          [styles.button__icon__modDisabled]: disabled,
        })}
        src={iconProps?.iconSrc}
        alt="button icon"
        width={20}
        height={20}
      />
    );
  }

  return (
    <Image
      className={classNames(styles.button__icon, iconProps.iconClassName, {
        [styles.button__icon__modDisabled]: disabled,
      })}
      src={iconProps?.iconSrc}
      alt="button icon"
      width={20}
      height={20}
    />
  );
};
